<div class="modal inmodal fade in create-modal" [ngClass]="{'show': showModal}">
    <form #form="ngForm" (ngSubmit)="onSubmit(form)" submittable autocomplete="off">
        <div class="modal-dialog ">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" (click)="hideModal(form)">
                        <span>×</span>
                        <span class="sr-only">Close</span>
                    </button>
                    <h4 class="modal-title">
                        Change Unit
                    </h4>
                </div>
                <div class="modal-body">
                    <!-- ___ Building ___ -->
                    <div class="row m-b-sm">
                        <div class="col-md-4">
                            <label>Building</label>
                        </div>
                        <div class="col-md-8 fourteenPixelText">
                            <select class="form-control" name="moveInToBuildingId" [(ngModel)]="moveInToBuildingId"
                                    style="height: 28px;padding: 0 12px;" required
                                    (change)="changeBuilding($event.target.value)" #buildingSelect
                                    [disabled]="buildings.length === 0 || buildingSelectIsDisabled">
                                <option value="" hidden></option>
                                <option *ngFor="let build of buildings" [value]="build.id">{{build.name}}</option>
                            </select>
                            <spinner [spinnerShow]="buildings.length === 0"></spinner>
                        </div>
                    </div>

                    <!-- ___ Unit ___ -->
                    <div class="row m-b-sm">
                        <div class="col-md-4">
                            <label>Unit</label>
                        </div>
                        <div class="col-md-8">
                            <search-select [(ngModel)]="moveInToSuiteId" name="moveInToSuiteId" required
                                           #suiteSelect [data]="suiteToSearchSelect(suites)"></search-select>
                            <spinner [spinnerShow]="buildingSelect.value &&
                                                    buildingSelect.value != 'null' &&
                                                    !suites.length"></spinner>
                        </div>
                    </div>

                    <div class="row text-center m-t-md">
                        <button class="btn btn-primary submit-btn" [disabled]="disabledSubmit">Move</button>
                    </div>
                    <spinner [spinnerShow]="showSpinner"></spinner>
                </div>
            </div>
        </div>
    </form>
    <div class="modal-backdrop fade in" (click)="hideModal(form)"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/components/directory/change-unit-modal/change-unit-modal.component.html